import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';

export const ApplicationSettingTypeOrder = [
    ApplicationSettingsType.CoreLocal,
    ApplicationSettingsType.CoreCentral,
    ApplicationSettingsType.CoreGlobal,
    ApplicationSettingsType.DocumentLocal,
    ApplicationSettingsType.DocumentCentral,
    ApplicationSettingsType.DocumentGlobal,
    ApplicationSettingsType.MediaBankLocal,
    ApplicationSettingsType.MediaBankCentral,
    ApplicationSettingsType.MediaBankGlobal,
    ApplicationSettingsType.PostLocal,
    ApplicationSettingsType.PostCentral,
    ApplicationSettingsType.PostGlobal,
    ApplicationSettingsType.Appearance,
    ApplicationSettingsType.Tag,
    ApplicationSettingsType.StatisticsLocal,
    ApplicationSettingsType.StatisticsCentral,
    ApplicationSettingsType.Email,
    ApplicationSettingsType.SMS,
    ApplicationSettingsType.Forum,
    ApplicationSettingsType.ForumAdmin,
    ApplicationSettingsType.ChecklistLocal,
    ApplicationSettingsType.ChecklistCentral,
    ApplicationSettingsType.ChecklistGlobal,
    ApplicationSettingsType.CheckListReports,
    ApplicationSettingsType.ChecklistV2Local,
    ApplicationSettingsType.ChecklistV2Central,
    ApplicationSettingsType.ChecklistV2Global,
    ApplicationSettingsType.ChecklistV2Reports,
    ApplicationSettingsType.ChecklistV2AuditLocal,
    ApplicationSettingsType.ChecklistV2AuditCentral,
    ApplicationSettingsType.ChecklistV2AuditGlobal,
    ApplicationSettingsType.ChecklistV2AuditReports,
    ApplicationSettingsType.FormLocal,
    ApplicationSettingsType.FormCentral,
    ApplicationSettingsType.FormGlobal,
    ApplicationSettingsType.FormReports,
    ApplicationSettingsType.Chat,
    ApplicationSettingsType.ConfidentialAgreement,
    ApplicationSettingsType.TaskV2Local,
    ApplicationSettingsType.TaskV2Central,
    ApplicationSettingsType.TaskV2Global,
    ApplicationSettingsType.TaskV2Reports,
    ApplicationSettingsType.LoginReminder,
];
